// METIS Hub wording — namespace "logs" (ko), 369 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/screens/logs.js App.addI18n).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const logs: Record<string, string> = {
  "logs.kicker.me": "내 기록",
  "logs.kicker.team": "우리 팀 · {team}",
  "logs.kicker.all": "회사 전체",
  "logs.kicker.allTeam": "전체 · {team}만",
  "logs.desc": "{range} · 한국 시간 · 기준 {asof}",
  "logs.search.label": "기록 찾기",
  "logs.search.ph.me": "질문 글·파일 이름·대화 번호",
  "logs.search.ph.wide": "대화 번호(#1234) · 내 기록은 글로도",
  "logs.search.hint.me": "검색: 내 기록의 질문 글·파일 이름·대화 번호로 찾아요.",
  "logs.search.hint.wide": "검색: 다른 사람 기록은 대화 번호로만 찾아요. 질문 글·파일 이름 검색은 내 기록에서만 돼요.",
  "logs.cond.title": "조건",
  "logs.cond.button": "조건",
  "logs.cond.buttonN": "조건 {n}",
  "logs.cond.sheet": "조건 고르기",
  "logs.cond.clear": "조건 지우기",
  "logs.cond.apply": "적용",
  "logs.cond.q": "검색어 {q}",
  "logs.cond.applied": "조건을 적용했어요",
  "logs.cond.cleared": "조건을 모두 지웠어요",
  "logs.f.method": "사용 방식",
  "logs.f.tool": "도구",
  "logs.f.model": "AI 모델",
  "logs.f.surface": "실행 위치",
  "logs.f.person": "사람",
  "logs.f.any": "전체",
  "logs.f.na": "이 조건에 맞는 기록이 없어요",
  "logs.f.periodHint": "기간은 위 기간 고르기에서 바꿔요.",
  "logs.f.periodTeamHint": "기간은 위 기간 고르기에서, 팀은 머리줄 보기 범위 옆에서 바꿔요.",
  "logs.f.team": "팀",
  "logs.list.q": "어떤 대화를 했나요?",
  "logs.list.q.team": "우리 팀은 어떤 대화를 했나요?",
  "logs.list.q.all": "회사에서 어떤 대화가 있었나요?",
  "logs.list.tech": "대화 {n}건 · 최신순 · 누르면 기록 상세로 가요",
  "logs.list.sum": "{period} 동안 대화 {n}건, 질문 {p}개가 있었어요(사용량 {tok}).",
  "logs.list.selfOnlyTitle": "여기에는 내 대화만 보여요",
  "logs.list.selfOnlyGo": "통계 열기",
  "logs.list.selfOnly": "지금 역할({role})은 다른 사람의 대화 목록을 열 수 없어요. 회사·팀 숫자는 통계에서 봐요.",
  "logs.list.range": "{from}–{to} / {n}건",
  "logs.list.viewed": "열람됨",
  "logs.list.viewedTip": "다른 사람이 이 대화의 글을 열람했어요",
  "logs.list.gw": "CLI(게이트웨이 경유) {n}건 · 중복 확인 중 — PC에서 보낸 기록에 같은 호출이 있는지 확인하기 전이라 목록과 합계에 넣지 않았어요. 없으면 약 10분 뒤에 들어오고, 확인할 수 없는 호출은 두 번 세지 않도록 계속 빼요.",
  "logs.col.when": "시각",
  "logs.col.person": "사람",
  "logs.col.tool": "도구",
  "logs.col.title": "제목",
  "logs.empty.what": "이 기간에 맞는 대화 기록이 없어요.",
  "logs.empty.next": "연결 상태 보기",
  "logs.nores.title": "조건에 맞는 대화가 없어요",
  "logs.nores.desc": "조건을 하나 빼 보세요.",
  "logs.nores.drop": "‘{label}’ 조건을 빼면 {n}건 있어요",
  "logs.nores.period": "기간을 90일로 넓히면 {n}건 있어요",
  "logs.nores.clear": "조건 모두 지우기",
  "logs.pager": "대화 목록 쪽 이동",
  "logs.export": "내보내기",
  "logs.export.kicker": "내보내기 · 가명 · 글 제외",
  "logs.export.title": "대화 목록을 내보낼까요?",
  "logs.export.desc": "지금 조건의 대화 {n}건을 CSV로 내보내요. 이름은 가명으로, 질문·답변 글은 빼고 담아요.",
  "logs.export.cols": "담기는 칸: 대화 번호 · 시각 · 사람(가명) · 도구 · 질문 수 · 사용량 · 대화가 열려 있던 시간 · 기록 수준",
  "logs.export.head": "파일 머리말(CSV)",
  "logs.export.scope": "내보내기 권한 범위({scope}) 안의 {n}건만 담아요(목록 {m}건 중).",
  "logs.export.go": "내보내기",
  "logs.export.done": "내보내기 기록을 남겼어요(목업이라 파일은 만들지 않아요)",
  "logs.export.h1": "내보낸 사람 역할: {role} · 조건: {cond}",
  "logs.export.h2": "금지 용도: 근무·성과 평가에 쓰지 않아요 · 가림 한계: 자동 가림이 모든 개인정보를 찾지는 못해요",
  "logs.detail.page": "기록 상세",
  "logs.detail.q": "이 대화에서 무슨 일이 있었나요?",
  "logs.detail.kicker": "기록 상세",
  "logs.detail.kickerNo": "기록 상세 · 대화 #{no}",
  "logs.crumb.no": "대화 #{no}",
  "logs.nf.title": "이 기록을 찾을 수 없어요",
  "logs.nf.desc": "주소가 맞는지 확인하세요. 볼 수 있는 범위 밖의 기록도 이렇게 보여요.",
  "logs.nf.back": "사용 기록으로",
  "logs.band.label": "대화 요약",
  "logs.band.person": "사람",
  "logs.band.tool": "도구",
  "logs.band.when": "시각",
  "logs.band.prompts": "질문",
  "logs.band.calls": "호출",
  "logs.band.modelMore": "{model} 외 {n}개",
  "logs.band.me": "(나)",
  "logs.badge.auth": "결제 방식: {v}",
  "logs.badge.authClaude": "기기에서 마지막으로 확인한 방식이에요(확인 {time})",
  "logs.badge.authNone": "아직 확인하지 못했어요",
  "logs.badge.authReq": "요청마다 확인한 방식이에요",
  "logs.badge.tamperOk": "위변조 검사 ✓",
  "logs.badge.tamperOkTip": "받은 뒤 바뀌지 않았어요(해시 체인 · 외부 고정점 {date} 일치)",
  "logs.badge.tamperBad": "위변조 의심",
  "logs.badge.tamperDemoTip": "목업 전용 시연이에요(열람·변경 이력 #{seq}). 열람·변경 이력에서 [지금 검사]를 누르면 원래대로 보여요.",
  "logs.badge.hold": "법적 보관 중",
  "logs.badge.holdTip": "조사 증거로 보존해서 보관 기간이 지나도 지우지 않아요",
  "logs.badge.expired": "글 보관 기간 지남",
  "logs.badge.expiredTip": "글은 30일만 보관해요. 사용량·기본 정보는 180일 남아요.",
  "logs.badge.checking": "지원 여부 확인 중 · {v}",
  "logs.badge.old": "지원 버전보다 낮음 · {v}",
  "logs.more.label": "기록 상세 메뉴",
  "logs.more.raw": "기술 상세",
  "logs.more.rawDesc": "권한으로 걸러진 원본 구조(JSON)",
  "logs.more.copy": "링크 복사",
  "logs.more.copyDesc": "받는 사람 권한으로 다시 판정돼요",
  "logs.more.prev": "이전 기록",
  "logs.more.next": "다음 기록",
  "logs.more.none": "더 없어요",
  "logs.copied": "링크를 복사했어요",
  "logs.raw.kicker": "기술 상세 · 대화 #{no}",
  "logs.raw.title": "받은 기록의 구조",
  "logs.raw.desc": "보관한 기록 구조를 보여 줘요. 저장하지 않은 항목과 지금 볼 수 없는 글 칸은 제외했어요.",
  "logs.raw.hidden": "(가림 · 권한 필요)",
  "logs.raw.hiddenReason": "(가림 · 사유를 남기면 보여요)",
  "logs.raw.none": "(기록 없음 · {reason})",
  "logs.raw.note": "실제 API 본문은 기본 정책상 받지 않아요.",
  "logs.raw.hash": "해시 ",
  "logs.tab.label": "기록 상세 보기",
  "logs.tab.qa": "질문·답변",
  "logs.tab.usage": "사용량·시간",
  "logs.tab.actions": "AI가 한 작업",
  "logs.tab.files": "파일·바뀐 내용",
  "logs.tab.timeline": "진행 순서",
  "logs.tab.na": "이 사용 방식엔 해당 없음",
  "logs.viewed.title": "다른 사람이 이 대화의 글을 {n}번 열람했어요",
  "logs.viewed.desc": "가장 최근: {role} · {time} · 사유 범주: {cat}",
  "logs.viewed.go": "누가 내 기록을 봤나요",
  "logs.grant.title": "열람 허가 중이에요",
  "logs.grant.note": "이 대화만 볼 수 있어요 · 열람 기록은 당사자에게 표시돼요",
  "logs.qa.q": "어떤 질문과 답변이 오갔나요?",
  "logs.qa.tech": "질문 {p}개 · AI 답변 {a}개 · 질문·답변 글",
  "logs.qa.tech.api": "호출 {p}건 · 호출마다 마지막 질문·답변",
  "logs.qa.techLocked": "질문 {p}개 · 질문·답변 글",
  "logs.qa.techLocked.api": "호출 {p}건 · 질문·답변 글",
  "logs.qa.sum": "질문 {p}개와 AI 답변 {a}개가 남아 있어요.",
  "logs.qa.sum.noA": "질문 {p}개가 남아 있어요. AI 답변 글은 남지 않았어요({reason}).",
  "logs.qa.sum.api": "호출 {p}건의 마지막 질문·답변이 남아 있어요.",
  "logs.qa.sum.locked": "이 대화의 글은 저장되어 있지만 지금은 볼 수 없어요.",
  "logs.qa.sum.none": "이 대화에는 볼 수 있는 질문 글이 없어요.",
  "logs.qa.qLabel": "질문 {n}",
  "logs.qa.callLabel": "호출 {n}",
  "logs.qa.aLabel": "AI 답변",
  "logs.qa.chars": "{n}자",
  "logs.qa.slash": "/명령",
  "logs.qa.refused": "AI가 정책상 답변을 거절했어요",
  "logs.qa.thinking": "AI의 중간 생각은 저장하지 않아요.",
  "logs.qa.redact": "▇ 표시는 저장하기 전에 가린 부분이에요.",
  "logs.qa.more": "나머지 {n}개 더 보기",
  "logs.qa.empty": "이 대화에 볼 수 있는 질문·답변이 없어요.",
  "logs.contentSearch.label": "이 대화의 글 찾기",
  "logs.contentSearch.go": "찾기",
  "logs.contentSearch.clear": "검색 지우기",
  "logs.contentSearch.loading": "찾고 있어요…",
  "logs.contentSearch.count": "질문·답변 {n}개에서 찾았어요.",
  "logs.contentSearch.truncated": "처음 100개를 보여 드려요. 검색어를 더 구체적으로 적어 주세요.",
  "logs.contentSearch.prompt": "질문 {n}",
  "logs.contentSearch.answer": "답변 {n}",
  "logs.export.kind": "내보낼 내용",
  "logs.export.kind.rows": "행(가명·글 제외)",
  "logs.export.kind.identity": "행과 실명",
  "logs.export.kind.content": "행과 질문·답변(가명)",
  "logs.export.format": "파일 형식",
  "logs.export.previewSafe": "미리보기에는 가명 행만 표시해요.",
  "logs.export.reasonRequired": "사유 범주를 고르고 사유를 10자 이상 적어 주세요.",
  "logs.export.grantRequired": "다른 사람의 글은 대상 대화에서 먼저 열람 허가를 받아야 해요. 허가가 없거나 만료된 대화가 있으면 파일을 만들지 않아요.",
  "logs.export.doneJson": "JSON 파일을 내려받았어요. 내보낸 기록도 남겼어요.",
  "logs.read.size": "글자 크기",
  "logs.read.s": "작게",
  "logs.read.m": "보통",
  "logs.read.l": "크게",
  "logs.read.wrap": "긴 줄 바꿈",
  "logs.lock.mgr.title": "매니저는 기본적으로 팀원의 글을 볼 수 없어요",
  "logs.lock.mgr.desc": "팀 기록의 기본 정보와 사용량만 봐요. 켜려면 관리자 설정과 2차 승인이 필요해요.",
  "logs.lock.meta.title": "이 역할은 기본 정보만 봐요",
  "logs.lock.meta.desc": "질문·답변 글과 작업 상세는 열 수 없어요. 기본 정보와 열람·변경 이력으로 확인하세요.",
  "logs.lock.perm.title": "지금 역할로는 볼 수 없어요",
  "logs.lock.perm.desc": "이 대화의 글을 볼 권한이 없어요. 필요하면 관리자에게 요청하세요.",
  "logs.lock.level": "이 대화는 {level} 수준으로 기록돼 이 내용을 남기지 않았어요.",
  "logs.lock.expired": "글은 30일 동안만 보관해요. 사용량·기본 정보는 180일 동안 남아요.",
  "logs.lock.old": "지원 버전보다 낮은 CLI가 보낸 기록이라 글·작업 상세를 받지 않았어요.",
  "logs.lock.notSent": "CLI 설정에서 이 값을 보내지 않았어요. 도구 연결에서 설정을 다시 받으세요.",
  "logs.lock.denied": "최근 열람 요청이 거부됐어요 · {time}",
  "logs.lock.deniedWhy": "사유가 10자보다 짧았어요. 거부도 열람·변경 이력에 남아요.",
  "logs.lock.flow": "열람하면 이 대화만 {min}분 동안 볼 수 있고, 당사자의 ‘누가 내 기록을 봤나요’에 남아요.",
  "logs.lock.saved": "글은 저장되어 있어요 · {n}자",
  "logs.badge.authNote": "CLI 도구 카드의 결제 방식(구독 로그인·API 키·확인 안 됨)과 같은 기준이에요.",
  "logs.lock.savedDiff": "바뀐 내용이 저장되어 있어요 · 파일 {n}개 · +{a}/−{d}줄",
  "logs.lock.savedFiles": "파일 목록이 저장되어 있어요 · 파일 {n}개",
  "logs.diff.metricEst": "줄 수(패치에서 센 추정)",
  "logs.req.thinkTip": "AI가 쓴 양에 들어 있어요(합계에 더하지 않음)",
  "logs.band.more": "자세히",
  "logs.band.less": "접기",
  "logs.del.title": "삭제 요청으로 볼 수 없어요",
  "logs.del.desc.pending": "{date}에 삭제 요청이 들어와 바로 모든 화면의 목록·상세·합계에서 빠졌어요. {due}까지 처리돼요.",
  "logs.del.desc.done": "삭제 요청에 따라 {done}에 글과 식별자를 지웠어요. 비용 정산용 사용량만 가명 집계로 남아요.",
  "logs.del.desc.held": "삭제 요청을 받았지만 법적 보관 중이라 보류했어요. 조회는 계속 막혀 있어요.",
  "logs.del.own": "처리 상태는 내 기록·동의에서 볼 수 있어요.",
  "logs.del.other": "당사자의 요청이라 어떤 역할도 열 수 없어요.",
  "logs.del.mine": "내 삭제 요청 보기",
  "logs.use.q": "사용량은 어떻게 나뉘나요?",
  "logs.use.tech": "사용량(토큰) 4종 · 100% 막대 · 생각에 쓴 양은 AI가 쓴 양에 포함",
  "logs.use.tech3": "사용량(토큰) 3종 · 100% 막대 · 생각에 쓴 양은 AI가 쓴 양에 포함",
  "logs.use.sum": "모두 {tok} 중 ‘{kind}’{ga} 가장 많아요({p}).",
  "logs.use.total": "합계",
  "logs.use.totalEq": "요청별 표 합계·요약 띠의 사용량과 같아요",
  "logs.use.reasoningNote": "AI가 쓴 양 안에 들어 있어 합계에 더하지 않아요.",
  "logs.use.cwNote": "입력에 들어 있는지 확인 중이라 막대와 합계에 쌓지 않았어요.",
  "logs.use.failed": "실패한 요청 {n}건도 사용량이 수신됐으면 합계에 포함해요. 기록이 없으면 0으로 세지 않아요.",
  "logs.use.bar": "사용량 4종 비중",
  "logs.use.col.kind": "종류",
  "logs.use.col.share": "비중",
  "logs.use.empty": "이 대화에서 성공한 AI 요청이 없어요.",
  "logs.cost.q": "비용은 얼마로 추정되나요?",
  "logs.cost.tech": "추정 비용 · {kind} · 청구서 아님",
  "logs.cost.sum": "{kind} 기준으로 {usd}예요.",
  "logs.cost.kind": "비용 종류",
  "logs.time.q": "얼마나 오래 걸렸나요?",
  "logs.time.tech": "AI 사용 시간 · 대화가 열려 있던 시간 · 응답 대기",
  "logs.time.sum": "AI 응답은 보통 {a}, 느릴 때 {b} 기다렸어요.",
  "logs.time.waitV": "보통 {a} · 느릴 때 {b}",
  "logs.time.ttft": "첫 글자까지(보통)",
  "logs.model.q": "어떤 AI 모델과 생각 깊이를 썼나요?",
  "logs.model.tech": "AI 모델 {n}개 · 요청 수 · 사용량",
  "logs.model.sum": "{model}{ga} 요청 {n}건으로 가장 많아요.",
  "logs.model.req": "요청 {n}건",
  "logs.model.bg": "보조 요청 {n}건 포함",
  "logs.req.q": "요청별로 보면 어떤가요?",
  "logs.req.q.api": "호출별로 보면 어떤가요?",
  "logs.req.tech": "AI 요청 {n}건 · 시간순 · 합계 = 위 막대",
  "logs.req.sum": "가장 오래 기다린 요청은 {n}번째예요({d}).",
  "logs.req.col.no": "번호",
  "logs.req.col.when": "시각",
  "logs.req.col.usage": "사용량",
  "logs.req.col.wait": "응답 대기",
  "logs.req.col.result": "결과",
  "logs.req.ok": "성공",
  "logs.req.retryOk": "다시 시도해 성공",
  "logs.req.bg": "보조",
  "logs.req.bgTip": "제목 만들기처럼 화면 뒤에서 부른 가벼운 요청이에요",
  "logs.req.more": "나머지 {n}건 더 보기",
  "logs.req.title": "요청 {n}",
  "logs.req.titleApi": "호출 {n}",
  "logs.req.successCount": "성공한 요청 {n}건",
  "logs.req.cwHead": "검증 중 · 합계 제외",
  "logs.wf.col": "시간축",
  "logs.wf.label": "시간축 막대",
  "logs.wf.wait": "기다림(첫 글자까지)",
  "logs.wf.rest": "나머지(AI 처리·받기)",
  "logs.wf.one": "한 색(나눌 수 없음)",
  "logs.wf.fail": "실패한 요청",
  "logs.wf.gap": "≈ 1분 넘게 쉰 뒤에는 그 줄부터 시간축을 처음부터 다시 그려요",
  "logs.wf.after": "{d} 쉰 뒤 다시 시작",
  "logs.wf.note": "막대는 대화 안에서 요청이 언제 시작해 얼마나 걸렸는지예요. 모든 줄이 같은 비율이에요.",
  "logs.wf.aria": "{when} 시작 · 기다림 {w} · 나머지 {r}",
  "logs.wf.ariaOne": "{when} 시작 · 걸린 시간 {d}",
  "logs.wf.ariaFail": "{when} 시작 · 실패 · {d}",
  "logs.act.q": "AI가 어떤 작업을 했나요?",
  "logs.act.tech": "AI가 한 작업 · 기타 기록 6가지 · 줄마다 원래 이벤트 이름",
  "logs.act.sum": "AI가 작업 {n}번을 했어요(명령 {c}번 · 거절 {r}번 · 오류·재시도 {e}번).",
  "logs.act.sum.api": "API 키 호출에는 AI가 한 작업이 없어요. 오류·재시도가 {e}건 있어요. 호출 순서는 진행 순서 탭에서 봐요.",
  "logs.act.sum.apiNoErr": "API 키 호출에는 AI가 한 작업이 없고, 오류·재시도도 없었어요. 호출 순서는 진행 순서 탭에서 봐요.",
  "logs.cat.label": "기록 종류",
  "logs.cat.tool": "도구 실행",
  "logs.cat.command": "명령 실행",
  "logs.cat.decision": "허용·거절",
  "logs.cat.error": "오류·재시도",
  "logs.cat.system": "실행 환경",
  "logs.cat.access": "이 기록의 열람·내보내기",
  "logs.act.actor": "허용·거절을 결정한 쪽",
  "logs.act.lockDetail": "명령 전문·파일 경로는 잠겨 있어요. 작업 이름과 결과만 보여요.",
  "logs.act.levelDetail": "기록 수준 ④가 아니라 명령 전문·파일 경로는 남기지 않았어요.",
  "logs.act.expiredDetail": "보관 기간이 지나 명령 전문·파일 경로는 지웠어요.",
  "logs.act.empty": "고른 종류의 기록이 없어요.",
  "logs.act.pager": "AI 작업 기록 쪽 이동",
  "logs.act.accessHidden": "이 기록의 열람 이력은 당사자와 열람·변경 이력을 볼 수 있는 사람만 봐요.",
  "logs.act.view": "{who} 열람 · {cat}",
  "logs.act.viewDenied": "{who} 열람 거부 · 사유가 10자보다 짧았어요",
  "logs.act.noViews": "아직 이 대화의 글을 연 사람이 없어요.",
  "logs.act.locked": "잠김",
  "logs.act.na": "이 사용 방식엔 해당 없음",
  "logs.files.q": "AI가 어떤 파일을 열어 보고 고쳤나요?",
  "logs.files.tech": "AI가 열어 본 파일 {r}개 · 고친 파일 {e}개",
  "logs.files.sum": "파일 {n}개를 다뤘고 그중 {e}개를 고쳤어요.",
  "logs.files.sumNone": "이 대화에서 AI가 다룬 파일이 없어요.",
  "logs.files.view": "보기 방식",
  "logs.files.list": "목록",
  "logs.files.tree": "트리",
  "logs.files.label": "AI가 열어 본·고친 파일",
  "logs.files.scroll": "파일 목록 · 위아래로 넘겨 봐요",
  "logs.files.op.read": "열어 봄",
  "logs.files.op.edit": "고침",
  "logs.files.op.create": "만듦",
  "logs.files.op.delete": "지움",
  "logs.files.est": "추정",
  "logs.files.times": "{n}번",
  "logs.files.pickHint": "파일을 고르면 그 파일의 바뀐 내용을 보여 줘요.",
  "logs.split.handle": "파일 목록 폭",
  "logs.split.tip": "← → 키로 폭을 바꾸고 Esc로 처음 폭으로 돌아가요",
  "logs.files.claudeNote": "AI가 셸 명령(cat 등)으로 연 파일은 이 목록에 없을 수 있어요.",
  "logs.files.codexNote": "패치로 고친 파일은 그대로 셌어요. 셸 명령으로 열거나 만든 파일은 명령 글에서 뽑은 추정이에요(추정 표시). 명령에 내용이 들어 있으면 새로 쓴 내용을 보여 줘요.",
  "logs.files.labelOnly": "지금은 마지막 두 단계 이름표만 보여요. 전체 경로와 바뀐 내용은 사유를 남긴 뒤 보여요.",
  "logs.files.expiredNote": "보관 기간이 지나 전체 경로는 지웠어요. 이름표만 남아 있어요.",
  "logs.files.countsOnly": "파일 이름은 볼 수 없어요. 개수만 보여요.",
  "logs.files.countsLine": "열어 본 파일 {r}개 · 고친 파일 {e}개",
  "logs.files.folder": "{name} 폴더",
  "logs.diff.q": "무엇이 바뀌었나요?",
  "logs.diff.tech": "바뀐 내용 · 파일 {n}개 · 추가 {a}줄 · 삭제 {d}줄",
  "logs.diff.sum": "파일 {n}개에서 {a}줄을 더하고 {d}줄을 지웠어요.",
  "logs.diff.none": "이 대화에서 바뀐 파일은 없어요.",
  "logs.diff.metric": "줄 수 지표(CLI가 보낸 값)",
  "logs.diff.metricV": "추가 {a} · 삭제 {d}",
  "logs.diff.noneRec": "고친 파일 {e}개의 바뀐 내용은 기록에 남지 않았어요.",
  "logs.diff.fewerNote": "고친 파일 {e}개 중 {n}개만 바뀐 내용이 남았어요.",
  "logs.diff.metricNote": "줄 수 지표는 CLI가 대화 전체에서 센 값이라 아래 바뀐 내용보다 클 수 있어요.",
  "logs.diff.codexNote": "Codex는 패치 전체를 보내요. 줄 수는 패치에서 센 값이에요.",
  "logs.diff.truncNote": "일부만 남았어요. Claude Code는 값마다 앞 128자까지만 보내요(원래 길이는 …[N chars]로 표시). 아주 긴 변경은 보관 한도에서도 잘릴 수 있어요.",
  "logs.diff.showing": "{name} 파일의 바뀐 내용을 보여요",
  "logs.diff.readOnly": "AI가 이 파일을 열어 보기만 해서 바뀐 내용이 없어요.",
  "logs.diff.notKept": "이 파일을 고쳤지만 바뀐 내용은 기록에 남지 않았어요.",
  "logs.diff.deleted": "AI가 이 파일을 지웠어요. 지운 내용은 기록에 남지 않아요.",
  "logs.tl.q": "어떤 순서로 진행됐나요?",
  "logs.tl.tech": "질문 → AI 호출 → 도구 실행·허용/거절 → 결과 → 답변 · 막대는 걸린 시간",
  "logs.tl.sum": "질문 {p}개에 AI 호출 {r}번, 작업 {a}번이 이어졌어요.",
  "logs.tl.sum.api": "호출 {r}번을 보냈고, 응답 대기는 모두 {d}{yeo}.",
  "logs.tl.sum.apiRetry": "호출 {r}번(실패 {f}번 포함)을 보냈고, 응답 대기는 모두 {d}{yeo}.",
  "logs.tl.tech.api": "호출 순서 · 막대는 걸린 시간",
  "logs.tl.turn": "질문 {n}",
  "logs.tl.unlinked": "질문과 연결되지 않은 기록",
  "logs.tl.turnSlash": "/명령",
  "logs.tl.turnMeta": "AI 호출 {r}번 · 작업 {a}번 · {d}",
  "logs.tl.noCalls": "AI 호출 없음",
  "logs.tl.metaOnly": "글을 볼 수 없어 단계 이름과 시간만 보여요.",
  "logs.tl.wait": "응답 대기 {d} · 첫 글자까지 {f}",
  "logs.tl.promptLen": "질문 글 {n}자",
  "logs.tl.answerLen": "AI 답변",
  "logs.tl.call": "{model} · {tok}",
  "logs.tl.callNo": "호출 {n} · {model} · {tok}",
  "logs.tl.retry": "다시 시도했어요",
  "logs.tl.more": "나머지 {n}개 더 보기",
  "logs.tl.totals": "AI 응답 대기 합계 {a} · 작업 합계 {b} · 대화가 열려 있던 시간 {c}",
  "logs.tl.label": "진행 순서",
  "logs.tl.dec": "{decision} · 결정한 쪽: {actor}",
  "logs.tl.fail": "실패",
  "logs.tl.axis": "시간축",
  "logs.tl.axisView": "시간축 보기",
  "logs.tl.axisAll": "전체",
  "logs.tl.axisZoom": "확대 +",
  "logs.tl.rangeAll": "대화 전체 · {from}–{to}",
  "logs.tl.rangeTurn": "{turn} 확대 · {from}–{to} · {d}",
  "logs.tl.fold": "≈ 1분 넘게 쉰 틈은 접었어요",
  "logs.tl.pick": "구간 고르기 — 고른 뒤 확대 + 를 누르면 그 구간만 크게 펼쳐요",
  "logs.tl.lane.talk": "질문·답변",
  "logs.tl.lane.call": "AI 호출",
  "logs.tl.lane.work": "AI가 한 작업",
  "logs.tl.zoomAria": "{turn} 확대 시간축 · {from}–{to} · {meta} · 오류 {e}번",
  "logs.linked.subagents": "하위 에이전트 {n}",
  "logs.linked.helpers": "보조 요청 {n}",
  "logs.linked.listTip": "이 대화 안에서 실행된 하위 에이전트·보조 요청이에요. 사용량과 작업 수는 이 대화에 합쳐 보여 줘요.",
  "logs.linked.subagent": "하위 에이전트",
  "logs.linked.helper": "보조 요청",
  "logs.linked.helperName.title": "제목 만들기",
  "logs.linked.actions": "작업 {n}번",
  "logs.linked.rows": "{n}줄",
  "logs.linked.tokens": "토큰 {n}",
  "logs.linked.estimated": "추정 연결",
  "logs.linked.open": "따로 보기 (대화 #{no})",
  "logs.linked.request": "요청",
  "logs.linked.answer": "답변",
  "logs.linked.empty": "보여 줄 내용이 없어요.",
  "logs.linked.unavailable": "내용을 불러오지 못했어요.",
  "logs.linked.actionsTitle": "하위 에이전트·보조 요청이 한 작업",
  "logs.linked.parent.subagent": "대화 #{no} 안에서 실행된 하위 에이전트의 기록이에요",
  "logs.linked.parent.helper": "대화 #{no}를 위해 CLI가 따로 보낸 보조 요청이에요",
  "logs.linked.parent.open": "원래 대화 보기",
  "logs.linked.withSubagents": "하위 포함 {n}",
};

export default logs;
